
// 多语言翻译对象
const translations = {
  'en': 'Show All Sizes In This Color',
  'fr': 'Toutes les tailles en cette couleur',
  'es': 'Todas las tallas en este color',
  'ko': '이 컬러 전체 사이즈',
  'de': 'Alle Größen in dieser Farbe',
  'it': 'Tutte le taglie in questo colore',
  'pt-BR': 'Todos os tamanhos nesta cor',
  'nl': 'Alle maten in deze kleur'
};
// 获取翻译文本
function getTranslatedText(locale) {
  // 获取两位语言代码(如果是四位的话)
  const shortLocale = locale.split('-')[0];
  // 优先使用完整的语言代码匹配
  return translations[locale] || translations[shortLocale] || translations['en'];
}

// 检查URL中是否有color筛选参数并添加跳转卡片
function addAzazieRedirectCard() {
  // 移除已存在的卡片
  const existingCard = document.querySelector('.azazie-redirect-card');
  if (existingCard) {
    existingCard.remove();
  }

  // 检查URL中是否有color筛选参数
  const urlParams = new URLSearchParams(window.location.search);
  const colorParams = [];
  
  for (const [key, value] of urlParams.entries()) {
    if (key === 'filter.p.m.custom.az_color') {
      colorParams.push(decodeURIComponent(value));
    }
  }
  // 检查是否有color筛选或结果为空
  const isEmptyCollection = document.querySelector('.collection--empty');
  const EmptyCollectionWrapper = document.querySelector('.collection--empty .title-wrapper');
  if (colorParams.length > 0) {
    // 如果同时存在color筛选和空结果容器，隐藏空结果容器
    if (colorParams.length > 0 && isEmptyCollection) {
      EmptyCollectionWrapper.style.display = 'none';
    }
    const colorString = colorParams.join(',');
    const azazieColors = colorParams.map(color => 
      color.toLowerCase().replace(/\s+/g, '-')
    ).join(',');
    
    // 获取collection handle
    const collectionHandle = document.querySelector('[data-collection-handle]')?.dataset.collectionHandle;
    if (collectionHandle) {
        // 获取当前语言代码
      const currentLocale = document.documentElement.lang;
      let redirectUrl = 'https://www.azazie.com';
      
      // 如果不是英文,添加语言前缀
      if (currentLocale !== 'en') {
        redirectUrl += `/${currentLocale}`;
      }
      redirectUrl += `/all/${collectionHandle}/colors/${azazieColors}?utm_campain=pop-up-shopify`;

      const redirectCard = document.createElement('li');
      redirectCard.className = 'grid__item scroll-trigger animate--slide-in azazie-redirect-card';
      // redirectCard.style.cssText = 'grid-column: 1 / -1; text-align: center; ';
      
      redirectCard.innerHTML = `
        <a href="${redirectUrl}" target="_blank" rel="noopener noreferrer" style="display: inline-block; text-decoration: none; width:100%">
          <div style="background: #F7F7F7;cursor:pointer;display: flex;flex-direction: column;justify-content: center;align-items: center;color: #121212; width:100%;aspect-ratio: 190/263; margin: 0 auto;">
            <div style="font-size: 18px;font-weight: 500;margin-bottom: 0.5rem; text-decoration: underline;text-underline-offset: 3px;padding: 0 20px;text-align:center;">
              ${getTranslatedText(currentLocale)}
            </div>
          </div>
        </a>
      `;
      
      const productGrid = document.querySelector('#product-grid');
      if (productGrid) {
        productGrid.appendChild(redirectCard);
      } else if (isEmptyCollection) {
        // 添加到空结果容器
        redirectCard.style.cssText = 'lisyt-style:none;margin-top:20px';
        isEmptyCollection.appendChild(redirectCard);
      }
    }
  }
}

// 页面加载时执行
document.addEventListener('DOMContentLoaded', function() {
  addAzazieRedirectCard();
});
// // 监听筛选列表的点击事件
//   const colorFilterList = document.querySelector('.facets-layout.facets-layout-list.facets-layout-list--text.facets__list.list-unstyled');
//   if (colorFilterList) {
//     colorFilterList.addEventListener('click', function(e) {
//       // 检查点击的是否是li元素或其子元素
//       const clickedLi = e.target.closest('li');
//       if (clickedLi) {
//         console.log(333)
//         // 延迟执行，等待URL更新
//         setTimeout(addAzazieRedirectCard, 2000);
//       }
//     });
//   }
// 监听URL变化（用于AJAX筛选）
let currentUrl = window.location.href;
const observer = new MutationObserver(function() {
  console.log('URL CHANGE')
  if (window.location.href !== currentUrl) {
    console.log(window.location.href, currentUrl)
    currentUrl = window.location.href;
    setTimeout(addAzazieRedirectCard, 100); // 延迟执行，确保DOM更新完成
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});